import { useEffect, useState } from "react";
import { getDistrictName } from "../../../../utilities/common";
import OrderInfo from "../../SelectableOrderInfo/index";
import SlotSelect from "../SlotSelect";
import { Accordion, AccordionDetails, AccordionSummary, Badge, Typography, makeStyles } from "@material-ui/core";
import { ExpandMore, LocationOn } from "@material-ui/icons";
import _ from 'lodash';

const useStyles = makeStyles((theme)=> ({
    badgeWithoutContent: {
        transform: 'unset',
        right: 'unset'
    },
    accordianSetStyle: {
        flexDirection: 'column',
        alignItems: 'baseline'
    },
    flexStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: 40,
        width: '90%',
        alignItems: 'baseline',
        padding: 10
    },
    orderInfoStyle: {
        width: '80%'
    },
    textFieldStyle: {
        width: '20%'
    },
    badgeWithoutContent: {
        transform: 'unset',
        right: 'unset'
    }
}))
function AccountList(props){
    const classes = useStyles()

    const [expand, setExpand] =  useState(false);
    const [driverSlotsPair, setDriverSlotsPair] = useState({});
    const [withSlot, setWithSlot] = useState([]);
    const [slotConfiguration, setSlotConfiguration] = useState({});
    const [updatedWithSlot, setUpdatedWithSlot] = useState([]);
    const [dataCopy, setDataCopy] = useState([]);

    useEffect(() => {
        let driverSlots = {};
        let withSlots = [];
        for(const staffs in dataCopy) {
            const staffsInfo = dataCopy[staffs];        
            for(const staffInfo of staffsInfo) {
                withSlots[staffInfo.name] = 0;
                for(const staff of staffInfo) {
                    for(const slot of props.slotConfiguration) {
                        const index = slot.indexOf("\:");
                        const driverId = slot.slice(0, index);
                        const slotNo = slot.slice(index + 1);
                        if(driverId === staff.id + '' && slotNo !== 'undefined') {
                            driverSlots[staff.id] = slotNo;
                            withSlots[staffInfo.name]++;
                        }
                    }
                }
            }
        }
        setDriverSlotsPair(driverSlots);
        setWithSlot(withSlots);
        setUpdatedWithSlot(withSlots);
    }, [props.slotConfiguration])

    useEffect(() => {
        setWithSlot(updatedWithSlot);
    }, [updatedWithSlot])

    useEffect(() => {
        setWithSlot([]);
        setDriverSlotsPair({});
    }, [props.branch])

    useEffect(() => {
        let dataCurr = [];        
        if(props.data) {
            _.map(props.data, (staffs) =>{
                for(var i = 0; i < staffs.length; i++) {
                    if(staffs[i].zone) {
                        if(!dataCurr[staffs[i].zone]) {
                            dataCurr[staffs[i].zone] = [];
                        }
                        dataCurr[staffs[i].zone].push(staffs);
                        dataCurr[staffs[i].zone][dataCurr[staffs[i].zone].indexOf(staffs)].name = getDistrictName(staffs[i].district);
                        break;
                    }
                }
            })
            setDataCopy(dataCurr);
        }
    }, [props.data])
    
    return (
        <div style={{height: '100%', overflowY: 'scroll', overflowX: 'hidden'}}>
            {dataCopy && Object.keys(dataCopy).map((zoneName) => {
                return (
                    <Accordion key={zoneName} style={{width: '100%'}} onChange={_handleExpandAccordion}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
                                {zoneName}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordianSetStyle}>
                        {_.map(dataCopy[zoneName], (district, key) => {
                            return(
                            <Accordion key={key} style={{width: '100%'}} onChange={_handleExpandAccordion}>
                                <AccordionSummary expandIcon={<ExpandMore />}>
                                    <span style={{marginRight: '10px', width: '50px'}}>
                                        {withSlot[dataCopy[zoneName][key].name] || 0} / {Object.keys(dataCopy[zoneName][key]).length - 1}
                                    </span>
                                    <LocationOn />
                                    <Typography style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
                                        {dataCopy[zoneName][key].name}
                                    </Typography>
                                    &nbsp;
                                    <Badge
                                        color='error' 
                                        badgeContent={getDistrictDriverOrderCount(district)}
                                        max={99999}
                                        classes={{anchorOriginTopRightRectangle: classes.badgeWithoutContent}}
                                    />
                                </AccordionSummary>
                                <AccordionDetails className={classes.accordianSetStyle}>
                                {district.map((account, index) => (
                                    <div className={classes.flexStyle} style={ index % 2? { background : "#424242" }:{ background : "#303030" } }>
                                        <OrderInfo
                                            loading={props.sectionLoading}
                                            staffOrders={props.orderList[account.id]}
                                            filter={_.find(props.filter, {'driverId': account.id})}
                                            showPhoneNumber={props.showPhoneNumber}
                                            areaExpanded={expand}
                                            data={account}
                                            key={`order-info-${account.id}`}
                                            index={index}
                                            className={classes.orderInfoStyle}
                                        />
                                        <SlotSelect 
                                            driverSlotsPair={driverSlotsPair} 
                                            account={account} 
                                            manualEdit={props.manualEdit} 
                                            createSlotConfiguration={createSlotConfiguration} 
                                            withSlot={withSlot} 
                                            staffs={dataCopy[zoneName][key].name} 
                                            updateWithSlot={updateWithSlot} 
                                            clear={props.clear}
                                            handleClear={props.handleClear}
                                            resetClear={props.resetClear}
                                            handleExistSlot={props.handleExistSlot}
                                            zone={zoneName}
                                            existSlot={props.existSlot}
                                        />
                                    </div>
                                ))}
                                </AccordionDetails>
                            </Accordion>
                        )})}
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </div>
    )

    function updateWithSlot(updatedWithSlot) {
        setUpdatedWithSlot(updatedWithSlot);
    }

    function createSlotConfiguration(accountId, slotNo) {
        let currentSlotConfiguration = slotConfiguration;
        currentSlotConfiguration[accountId] = slotNo;   
        setSlotConfiguration(currentSlotConfiguration);
        props.saveNewSlotConfiguration(currentSlotConfiguration);
    }

    function _handleExpandAccordion(event, expanded){
        setExpand(expanded)
    }

    function getDistrictDriverOrderCount(drivers){
        let totalOrderCount = _.reduce(drivers, (sum, driver)=> {
            if(!_.has(driver, 'order_count')){
                return sum
            }
            return driver.order_count + sum
        }, 0)

        if (totalOrderCount === 0) return 0
        if (totalOrderCount > 0) return totalOrderCount
    }
}

AccountList.defaultProps = {
    id: 0,
    data: {},
    orderList: {},
    showPhoneNumber: false,
    sectionLoading: false
}

export default AccountList